<template>
    <!-- <v-alert outline class="py-1 ma-0" color="warning" icon="assessment" value="true" v-if="hasError">
        <div class="primary--text">
            {{ errorMessage || 'There\'s no graph data available.' }}
        </div>
    </v-alert> -->
    <div  :id="graphDivId"></div>

</template>

<script>
import Highcharts from 'highcharts'
import DataCharts from '@/components/mixins/DataCharts'
//import axios from 'axios'
import moment from 'moment'

export default {
  mixins: [DataCharts],
  props: {
    datasets: Array,
    analyte: String,
    locationType: String,
    queryDateRange: Object,
  },
  data() {
    return {
      loading: true,
      hasError: false,
      errorMessage: null,
    }
  },
  computed: {
    graphDivId() {
      return `${this.analyte}_${this.locationType}`
    },
    sortedDatasets() {
      if (!this.datasets) return []

      return [...this.datasets].sort((d1, d2) => {
        return new Date(d2.LastRecordDate) - new Date(d1.LastRecordDate)
      })
    },
    timeSeriesYAxisName() {
      return this.analyte + ' data of ' + this.locationType + ' stations'
    },
  },
  // watch: {
  //   analyte: {            
  //     handler(value) {
  //       this.generateGraph(value)
        
  //     },

  //   },
  // },
  methods: {
    generateGraph() {
      this.$nextTick(() => {
        const container = document.getElementById(this.graphDivId)
        if (container) {
          this.loading = true
          this.hasError = false
          this.errorMessage = null

          try {
            let args = this.constructGraphingArguments()
            this.drawChartWithArgs(args.config, args.data, { renderTo: this.graphDivId, tooltip: false })
            this.loading = false
            return


          } catch (e) {
            this.hasError = true
            this.loading = false
          }
        } else {
          console.log('the container div DOM is not rendered')
        }
          

      })

    },
    constructArgumentForSingleDataset(analyte, dataset, index) {
      let timeSeriesColor = Highcharts.getOptions().colors[index % 10]

      let dataSetConfig = {
        name: dataset.Location,
        type: this.decideChartType(analyte),
        yAxis: 0,
        color: timeSeriesColor,
      }

      return {
        dataset: dataSetConfig,
      }
    },
    constructGraphingArguments() {
      //let that = this
      let yAxisIndex = -1
      let datasets = []
      let timeRanges = []

      let yAxisConfig = { // Primary yAxis
        labels: {
          format: '',
          style: {
            color: '#434348',
          },
        },
        title: {
          text: this.timeSeriesYAxisName,
          style: {
            color: '#434348',
          },
        },
      }

      var seriesData = []
      this.datasets.forEach(matchedDataset => {
        yAxisIndex++
        let config = this.constructArgumentForSingleDataset(this.analyte, matchedDataset, yAxisIndex)
        timeRanges.push([this.queryDateRange.start, this.queryDateRange.end])
        datasets.push(config.dataset)

        var graphData = {
          name: matchedDataset.Location,
          data: matchedDataset.Points.map(x => [moment(x.DateTime).valueOf(), x.Value]),
          yAxis: config.dataset.yAxis,
          type: config.dataset.type,
          unit: matchedDataset.Points[0].Unit,
          color: config.dataset.color,
        }
        seriesData.push(graphData)

        var guidelineGraphData = {
          name: matchedDataset.Location + ' Guideline',
          data: matchedDataset.Guideline.map(x => [moment(x.DateTime).valueOf(), x.Value]),
          yAxis: config.dataset.yAxis,
          type: config.dataset.type,
          dashStyle: 'Dash',
          unit: matchedDataset.Guideline[0].Unit,
          color: config.dataset.color,
        }
        seriesData.push(guidelineGraphData)
      })

      if (yAxisIndex > -1) {
                // find the latest time range
        let tt = timeRanges.map(x => x[1].valueOf())
        let indexOfTimeRange = tt.indexOf(Math.max.apply(Math, tt))
        let latestTimeRange = timeRanges[indexOfTimeRange]

        let graphTitle = this.analyte + ' data of ' + this.locationType + ' station from ' + this.queryDateRange.start.format('YYYY-MMM-DD') + ' to ' + this.queryDateRange.end.format('YYYY-MMM-DD')
        let graphingArguments = {
          title: graphTitle,
          timeRange: latestTimeRange,
          datasets: datasets,
          yAxis: [yAxisConfig],
        }
        
        return {config: graphingArguments, data: seriesData}
      }
    },
  },
  mounted() {
    console.log('graph component mounted for ' + this.graphDivId)
    console.log(this.datasets)
    this.generateGraph()
  },
}
</script>